<a class="sh-list-row-title" [shNavigationLink]="getNavigationLink()" (click)="selectRecord($event)" [title]="getToolTip()">
  <h3 class="sh-list-row-title__title">{{ title }}</h3>
  @if (subtitle) {
    <small class="sh-list-row-title__info">{{ subtitle }}</small>
  }
</a>
